import CurrencyInputField from 'components/molecules/currency-input-field'
import InputField from 'components/molecules/input-field'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import LoaderButton from 'components/molecules/loader-button'
import customerRefundShipmentShipSchema from './customer-refund-shipment-ship-schema'

const propTypes = {
  onSubmit: PropTypes.func
}

const defaultProps = {
  onSubmit: () => {}
}

/**
 * Form to ship the Customer Refund Shipment
 * @param {func} onSubmit Handler to submit the form
 */
const CustomerRefundShipmentShipForm = ({ onSubmit }) => (
  <Formik
    enableReinitialize={ false }
    initialValues={{
      tracking_no : '',
      cost        : ''
    }}
    validationSchema={ customerRefundShipmentShipSchema }
    onSubmit={ onSubmit }
  >
    {
      (formikBag) => (
        <Form>
          <CurrencyInputField
            name='cost'
            label='cost'
            required={ true }
          />
          <InputField
            type='number'
            name='tracking_no'
            label='tracking number'
            required={ true }
          />
          <LoaderButton
            className='float-right'
            color='primary'
            type='submit'
            onSubmit={ formikBag.submitForm }
            disabled={ formikBag.isSubmitting }
            isLoading={ formikBag.isSubmitting }
            text='Ship'
          />
        </Form>
      )
    }
  </Formik>
)

CustomerRefundShipmentShipForm.propTypes     = propTypes
CustomerRefundShipmentShipForm.defaultPropes = defaultProps

export default CustomerRefundShipmentShipForm
